import { defineAsyncComponent } from '../compat/vueCompat';
import type { FolderUploadDialogRequest } from './folderUploadDialogRequest';
import { requestDialog } from './requestDialog';

const ItemAndFolderUploadDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/ItemAndFolderUploadDialog.vue'));

export function showFolderUploadDialog(req: FolderUploadDialogRequest) {
  requestDialog(req, ItemAndFolderUploadDialog);
}
